
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import InfoTooltip from '@/components/InfoTooltip.vue'

import { TsNpsSummaryEntity } from '@/entities/teamscoreboard'

@Component<TsNpsStats>({
    components: {
        InfoTooltip,
    },
})
export default class TsNpsStats extends Vue {
    @Getter public tsNpsSummary?: TsNpsSummaryEntity
    @Getter public tsScorecard

    public get positiveCount() {
        if (!this.tsScorecard || !this.tsScorecard.tsgroups) {
            return 0
        }

        return this.tsScorecard.tsgroups.reduce(
            (sum, current) => sum + current.respondedPromoter,
            0
        )
    }

    public get thingsToWorkOnCount() {
        if (!this.tsScorecard || !this.tsScorecard.tsgroups) {
            return 0
        }

        return this.tsScorecard.tsgroups.reduce(
            (sum, current) =>
                sum + (current.responded - current.respondedPromoter),
            0
        )
    }
}
